// extracted by mini-css-extract-plugin
module.exports = {"container":"trade_container__kc-El","sidebar":"trade_sidebar__QT0Ul","rightsection":"trade_rightsection__3vQIv"};